import BaseApiRequest from "./BaseApiRequest";
import { QUESTIONNAIRE_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class SubmitQuestionnaireRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = QUESTIONNAIRE_URL;

  constructor(request) {
    super();

    this.body = request;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
